import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

export default function Loader() {
  return (
    <div className="tw-grid tw-h-full tw-w-full">
      {" "}
      <CircularProgress className="tw-m-auto" variant="indeterminate" />
    </div>
  );
}
